<template>
  <el-dialog width="840px" title="定义时间配置" custom-class="cost-config-dlg" :show-close="false" :visible="show"
    @close="$emit('close')" :close-on-click-modal="false" destroy-on-close>
    <el-form class="context" :model="form_data">
      <div class="title">载重定义配置</div>

      <el-form-item label="载重定义开始时间:">
        <el-radio-group v-model="form_data.feikongcheStart">
          <el-radio :disabled="['in','out'].includes(it.value)" :key="'a' + it.value" :label="it.value" v-for="it in items.fahuodi">{{ it.label }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="载重定义结束时间:">
        <el-radio-group v-model="form_data.feikongcheEnd">
          <el-radio :key="'aa' + it.value" :label="it.value" v-for="it in items.fawangdi">{{ it.label }}</el-radio>

        </el-radio-group>
      </el-form-item>
      <el-divider />
      <div class="title">空车定义配置</div>

      <el-form-item label="空车定义开始时间:">
        <el-radio-group v-model="form_data.kongcheStart">
          <el-radio :key="'b' + it.value" :label="it.value" v-for="it in items.fahuodi">{{ it.label }}</el-radio>

        </el-radio-group>
      </el-form-item>
      <el-form-item label="空车定义结束时间:">
        <el-radio-group v-model="form_data.kongcheEnd">
          <el-radio :disabled="['in','out'].includes(it.value)" :key="'c' + it.value" :label="it.value" v-for="it in items.fawangdi">{{ it.label }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="btn-box">
        <el-button class="primary-btn" size="small" @click="fn_success">确定</el-button>
        <el-button class="default-btn" size="small" @click="$emit('close')">关闭</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>
<script>
import { Divider as ElDivider } from 'element-ui'
export default {
  components: { ElDivider },
  props: ['show', 'items', 'query'],
  data() {
    return {
      form_data: { "feikongcheStart": "", "feikongcheEnd": "", "kongcheStart": "", "kongcheEnd": "" }
    }
  },
  watch: {
    query: {
      handler(val) {
        for (let k in this.form_data) {
          this.form_data[k] = this.query[k]
        }
      },
      immediate: true
    }
  },
  methods: {
    fn_success() {
      this.$emit('success', { ...this.form_data })
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss">
$main_btn_color: #17B6A1;

.cost-config-dlg {
  .el-dialog__body {
    background-color: #F4F4FC;
    padding: 0.5rem 1rem;
  }

  .el-dialog__header {
    padding: 1rem;
    text-indent: 1rem;
  }

  .el-divider--horizontal {
    margin: 6px 0;
  }

  .primary-btn {
    background-color: $main_btn_color;
    letter-spacing: 2px;
    color: white;

    &:hover {
      background-color: lighten($main_btn_color, 3%);
    }
  }

  .default-btn {
    background-color: white;
    color: $main_btn_color;
    letter-spacing: 2px;

    &:hover {
      $default_color: lighten($main_btn_color, 3%);
      color: $default_color;
      border-color: $default_color;
    }
  }

  .context {
    background-color: white;
    border-radius: 6px;
    overflow: hidden;
    padding: 0.5rem 1rem;
    font-size: 14px;

    .title {
      font-size: 14px;
      padding: 0.5rem 0;
    }

    .btn-box {
      padding: 1rem 2rem;
      display: flex;
      justify-content: center;
      column-gap: 1rem;
    }

  }
}
</style>